module.exports = __webpack_public_path__ + "static/media/1.e2dd227f.png";